export const skills = [
  "HTML - semantic & accessible",
  "HTML - Responsive Web Design",
  "CSS - Grid/Flexbox",
  "CSS - BEM convention",
  "JavaScript",
  "TypeScript",
  "React",
  "React useState, useEffect, useRef",
  "React custom hooks",
  "React Router",
  "Redux Saga, Toolkit",
  "Tailwind CSS",
  "Bootstrap",
  "Styled Components",
  "Error handling",
  "Promises, Async/Await",
  "Working with API (fetch, axios)",
  "OpenAI API",
  "Immutability",
  "SQLite",
  "Vite, React Create App",
  "Git",
  "NPM",
  "Docker",
  "Postman",
  "Figma",
  "Storybook",
  "Airtable",
  "Teamwork",
  "GitHub Pull Requests & Review",
  "Scrum",
];

export const nextSkills = [
  "Node.js",
  "Next.js",
  "Three.js",
  "React Native",
  "React Testing Library",
  "WordPress/Drupal",
  "Firebase",
];
